export default {
    oidc: {
      issuer: 'https://id-dev.eaton.com/oauth2/default',
      clientId: '0oa8cqx5yoREM9eKB1d7',
      scopes: ['openid', 'profile', 'email'],
      redirectUri: `${window.location.origin}/login/callback`
    },
    widget: {
      issuer: 'https://id-dev.eaton.com/oauth2/default',
      clientId: '0oa8cqx5yoREM9eKB1d7',
      redirectUri: `${window.location.origin}/login/callback`,
      scopes: ['openid', 'profile', 'email'],
    }
  };
  